import styled from 'styled-components';

export const StyledWrapper = styled.div`
    max-width: 630px;
    width: 100%;
    margin: 0 auto;
`;
